export default "__VITE_ASSET__Dn$cLxLk__"